import { Table as RSTable } from 'reactstrap'
import styled from 'styled-components'
import colors from 'constants/colors'

export const Table = styled(RSTable)`
  thead th {
    border-top: 0 !important;
  }

  thead th {
    border-bottom: 1px;
  }

  th {
    color: ${colors.inputLabelGrey};
    font-weight: 500;
  }

  tbody td a {
    color: #5079C9;
  }
`
